<template>
    <modal :title="$t(newTitle)" :visible.sync="isShowDialog" width="50%">
        <div class="detail_t">
            <div class="content_t_l">
                <!-- 表单 -->
                <deviceForm v-bind="$attrs" :isMode="isMode" :handleText="handleText" ref="deviceForm" />
            </div>
            <!-- 图片 -->
            <div :class="isMode ? 'nocontent_t_r' : 'content_t_r'">
                <deviceUpload v-bind="$attrs" v-show="!isMode" ref="upload" />
                <img v-show="isMode" :src="$attrs.detailContent.pictureBase64" />
                <div v-if="isShowMsg" class="el-form-item__error">{{ $t('integration.picture_cannot_be_empty') }}</div>
            </div>
            <div class="handleIcon" v-if="handleText !== 'add'">
                <i :class="isMode ? 'el-icon-edit' : 'el-icon-back'" @click="modeChange"></i>
            </div>
        </div>
        <!-- tabs -->
        <el-tabs v-model="activeActiveCom" type="card">
            <el-tab-pane name="Attribute" :label="$t('integration.attribute')"></el-tab-pane>
        </el-tabs>
        <!-- 表格 -->
        <div class="content_b">
            <Attribute v-bind="$attrs" :isMode="isMode" :handleText="handleText" ref="Attribute" />
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import deviceForm from './deviceForm.vue';
import deviceUpload from './deviceUpload.vue';
import Attribute from './Attribute.vue';

import { deviceTypeAdd, deviceTypeEdited } from '@/api/modules/deviceType.js';

export default {
    props: ['title', 'isShow', 'handleText', 'tabsObj', 'deviceWay'],
    components: {
        deviceForm,
        deviceUpload,
        Attribute
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        }
    },
    watch: {
        title(newVal) {
            this.newTitle = newVal;
        }
    },
    data() {
        return {
            newTitle: '',
            isMode: false,
            isShowMsg: false,
            activeActiveCom: 'Attribute'
        };
    },
    methods: {
        modeChange() {
            this.isMode = !this.isMode;
            if (this.isMode) {
                this.newTitle = `${this.tabsObj.label || $t('public.sensor')}` + $t($t('integration.type_details'));
            } else {
                this.newTitle = $t($t('integration.edit')) + `${this.tabsObj.label || $t('public.sensor')}` + $t($t('integration.type_details'));
            }
        },
        // 清除数据以及校验
        clearValidate() {
            this.$refs['upload'].imageSuffix = '';
            this.$refs['upload'].imageUrl = '';
            this.isShowMsg = false;
            this.$nextTick(() => {
                this.$refs['deviceForm'].clearValidate();
                this.$refs['Attribute'].clearValidate();
            });
        },
        async handleSave() {
            const { imageSuffix, imageUrl } = this.$refs['upload'];
            const { dioForm } = this.$refs['deviceForm'];
            const { tableForm } = this.$refs['Attribute'];
            const flag1 = await this.$refs['deviceForm'].justify();
            const flag2 = await this.$refs['Attribute'].justify();

            this.isShowMsg = !imageUrl ? true : false;
            if (!flag1 || !flag2 || this.isShowMsg) return;

            let Query = {};
            Query = { ...dioForm };
            // 类型
            // Query.type = this.$parent.deviceWay;
            // 图片
            Query.uploadFileBase64 = imageUrl;
            Query.uploadFileSuffix = imageSuffix;
            // 属性
            Query.deviceTypePropertyList = tableForm.tableData;

            let httpUrl = deviceTypeAdd;
            if (this.handleText !== 'add') {
                httpUrl = deviceTypeEdited;
            } else {
                delete Query.id;
            }
            if (Query.status === '0') {
                this.$confirm(this.$t('public.tip_confirm'), this.$t('integration.tips'), {
                    confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                    cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                    type: 'warning'
                })
                    .then(() => {
                        this.httpFn(httpUrl, Query);
                    })
                    .catch(() => {});
            } else {
                this.httpFn(httpUrl, Query);
            }
        },
        httpFn(url, Query) {
            url(Query, this.deviceWay.toLowerCase()).then(({ result }) => {
                if (result) {
                    this.$message.success(this.$t('public.tip_oper_succ'));
                    this.isShowDialog = false;
                    this.$parent.getListFn();
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.detail_t {
    display: flex;

    .content_t_l {
        flex: 1;
    }

    .content_t_r,
    .nocontent_t_r {
        width: 200px;
        height: 200px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        position: relative;

        &::before {
            content: '*';
            position: absolute;
            left: -10px;
            color: red;
            margin-right: 4px;
        }

        img {
            width: 100%;
            height: 100%;
            display: block;
        }
    }

    .nocontent_t_r {
        &::before {
            content: '';
        }
    }

    .handleIcon {
        width: 30px;
        height: 100%;
        text-align: center;
        cursor: pointer;

        i {
            &:hover {
                color: red;
            }
        }
    }
}
</style>
